jQuery(function($){
	$('.sc-field-editor').on('click', '.upload-field .select-popup-button.upload', function(e) {
		e.preventDefault();

		let button = $(this);

		let mediaUploader;
		if(getDimensions(button)) {
			mediaUploader = getMediaUploader(button, true);
		} else {
			mediaUploader = getMediaUploader(button, false);
		}

		mediaUploader.open();
	});

	function getMediaUploader(button, crop) {
		let mediaUploader = wp.media.frames.customBackground = wp.media(getMediaUploaderOptions(button, false, crop));
		if(crop) {
			const cropControl = getCropControl(button);

			mediaUploader.on('cropped', function(croppedImage) {
				updateUploadDisplay(button, croppedImage.id);
			});

			mediaUploader.on('skippedcrop', function(selection) {
				updateUploadDisplay(button, selection.id);
			});

			mediaUploader.on('select', function() {
				const attachment = mediaUploader.state().get('selection').first().toJSON();
				if (cropControl.params.width  === attachment.width 
				&&  cropControl.params.height === attachment.height 
				&& !cropControl.params.flex_width 
				&& !cropControl.params.flex_height) {
					updateUploadDisplay(button, attachment.id);
					mediaUploader.close();
				} else {
					mediaUploader.setState('cropper');
				}

				//Ajax call to ensure file is on the server
				const data = {
					action: 'sc_field_editor_confirm_file_locally',
					attachment_id: attachment.id,
					attachment_url: attachment.url,
				};

				console.log(data);
				$.post('/wp-admin/admin-ajax.php', data, function(response){
					console.log(response);
				});
			});
		} else {
			mediaUploader.on('select', function() {
				const attachment = mediaUploader.state().get('selection').first().toJSON();
				console.log(attachment);
				button.closest('.upload-field').attr('filename', attachment.filename);
				updateUploadDisplay(button, attachment.id);
			});
		}

		return mediaUploader;
	}

	$('.sc-field-editor').on('click', '.select-popup-button.add-bulk', function(e) {
		e.preventDefault();

		let button = $(this);

		let mediaUploader = wp.media.frames.customBackground = wp.media(getMediaUploaderOptions(button, true));

		mediaUploader.on('select', function() {
			let attachmentIds = [];
			$.each(mediaUploader.state().get('selection').toJSON(), function(index, value){
				attachmentIds.push(value.id);
			});

			console.log(attachmentIds);

			//Add Bulk Media
			button.after('<div class="updating"><div class="loading-icon"></div> Updating...</div>');

			let data = {
				action: 'sc_field_editor_add_array_field_group',
				i: button.closest('.field.array').find('.array-field-group').length,
				post_id: button.attr('post_id'),
				field: button.attr('field'),
				field_info: button.attr('field_info'),
				new_values: attachmentIds
			};

			$.post('/wp-admin/admin-ajax.php', data, function(response){
				button.closest('.field.array').find('.sortable').append(response);
				button.closest('.field.array').find('.updating').remove();
			});
		});

		mediaUploader.open();
	});

	$('.sc-field-editor').on('click', '.upload-field .select-popup-button.remove', function(e) {
		e.preventDefault();

		let button = $(this).closest('.upload-field').find('.select-popup-button.upload');

		button.closest('.upload-field').attr('filename', '');
		updateUploadDisplay(button, '');
	});

	jQuery(document).on('scfe-upload-display-update', function(e, data) {
		e.preventDefault();
		console.log('SCFE upload display update triggered', data);
		if(data.hasOwnProperty('attachmentId') && data.attachmentId && data.hasOwnProperty('el') && data.el) {
			const button = data.el.closest('.field.upload').find('.select-popup-button.upload');
			updateUploadDisplay(button, data.attachmentId);
		}
	});

	function updateUploadDisplay(button, fieldValue) {
		button.after('<div class="updating"><div class="loading-icon"></div> Updating...</div>');
		let uploadField = button.closest('.upload-field').find('input[type=hidden]');
		let displayDiv = button.closest('.upload-field').find('.display');
		uploadField.val(fieldValue).trigger('change');

		let data = {
			action: 'sc_field_editor_update_upload_display',
			field_value: fieldValue,
			field_info: button.attr('field_info'),
			post_id: button.attr('post_id')
		};

		console.log(data);

		$.post('/wp-admin/admin-ajax.php', data, function(response){
			displayDiv.html(response);
		});
	}

	function getDimensions(button) {
		let dimensions = false;
		let fieldInfo = JSON.parse(atob(button.attr('field_info')));
		if(fieldInfo.hasOwnProperty('crop')) {
			if(fieldInfo.crop.hasOwnProperty('dimensions')) {
				if(fieldInfo.crop.dimensions.hasOwnProperty('width') && fieldInfo.crop.dimensions.hasOwnProperty('height')) {
					dimensions = fieldInfo.crop.dimensions;
				}
			}
		}

		return dimensions;		
	}

	function getMediaUploaderOptions(button, multiple = false, crop = false) {
		let dimensions = getDimensions(button);

		let librarySettings = {
			title:     'Select and Crop',
			library:   wp.media.query({type: 'image'}),
			multiple:  false,
			date:      false,
			priority:  20
		};
		if(dimensions) {
			librarySettings.suggestedWidth = dimensions.width;
			librarySettings.suggestedHeight = dimensions.height;
		}

		let cropSettings = {
			title: 'Choose ' + button.attr('label'),
			button: {
				text: 'Select and Crop ' + button.attr('label'),
				close: false
			},
			library: {
				type: button.attr('mime')
			},
			states: [
				new wp.media.controller.Library(librarySettings),
				new wp.media.controller.CustomizeImageCropper({ 
					imgSelectOptions: function(attachment, controller) {
						return getImgSelectOptions(attachment, controller);
					},
					control: getCropControl(button)
				})
			]
		};

		let noCropSettings = {
			title: 'Choose ' + button.attr('label'),
			button: {
				text: 'Choose ' + button.attr('label')
			}, 
			library: { 
				type: button.attr('mime') // limits the frame to show only appropriate mime type
			},
			multiple: multiple			
		}

		console.log(cropSettings);

		return crop ? cropSettings : noCropSettings;
	}

	function getCropControl(button) {
		let dimensions = getDimensions(button);
		let cropControl = {
			id: "control-id",
			params : {
				flex_width : false,  // set to true if the width of the cropped image can be different to the width defined here
				flex_height : true, // set to true if the height of the cropped image can be different to the height defined here
			}
		};

		console.log(dimensions);

		if(dimensions) {
			cropControl.params.width = dimensions.width;
			cropControl.params.height = dimensions.height;
		}

		cropControl.mustBeCropped = function(flexW, flexH, dstW, dstH, imgW, imgH) {

			// If the width and height are both flexible
			// then the user does not need to crop the image.
			if(true === flexW && true === flexH ) return false;

			// If the width is flexible and the cropped image height matches the current image height, 
			// then the user does not need to crop the image.
			if(true === flexW && dstH === imgH ) return false;

			// If the height is flexible and the cropped image width matches the current image width, 
			// then the user does not need to crop the image.        
			if(true === flexH && dstW === imgW) return false;

			// If the cropped image width matches the current image width, 
			// and the cropped image height matches the current image height
			// then the user does not need to crop the image.               
			if(dstW === imgW && dstH === imgH) return false;

			// If the destination width is equal to or greater than the cropped image width
			// then the user does not need to crop the image...
			if(imgW <= dstW) return false;

			return true;        
		};

		return cropControl;		
	}

	function getImgSelectOptions(attachment, controller) {
		var control = controller.get( 'control' );

		var flexWidth = !! parseInt( control.params.flex_width, 10 );
		var flexHeight = !! parseInt( control.params.flex_height, 10 );

		var realWidth = attachment.get( 'width' );
		var realHeight = attachment.get( 'height' );

		var xInit = parseInt(control.params.width, 10);
		var yInit = parseInt(control.params.height, 10);

		var ratio = xInit / yInit;

		controller.set( 'canSkipCrop', ! control.mustBeCropped( flexWidth, flexHeight, xInit, yInit, realWidth, realHeight ) );
		controller.set( 'canDeleteOriginal', true );

		var xImg = xInit;
		var yImg = yInit;

		if ( realWidth / realHeight > ratio ) {
			yInit = realHeight;
			xInit = yInit * ratio;
		} else {
			xInit = realWidth;
			yInit = xInit / ratio;
		}        

		//Correct size if too large
		if(xInit > 2560 || yInit > 2560) {
			var xDiff = 2560 / xInit;
			var yDiff = 2560 / yInit;

			var diffMultiplier = Math.min(xDiff, yDiff);

			xInit = parseInt(xInit * diffMultiplier);
			yInit = parseInt(yInit * diffMultiplier);
		}

		var minWidth = xImg > xInit ? xInit : xImg;
		var minHeight = yImg > yInit ? yInit : yImg;

		var cropMultiplier = .9;
		var actualRatio = realWidth / realHeight;
		var shorterDimensionOffset = actualRatio > 1 ? Math.ceil(realHeight * (1 - cropMultiplier)) : Math.ceil(realWidth * (1 - cropMultiplier));

		var dimensionLargerThanMin = realWidth * cropMultiplier > minWidth || realHeight * cropMultiplier > minHeight;

		var x1 = dimensionLargerThanMin ? (realWidth - xInit) / 2 + shorterDimensionOffset / 2 : (realWidth - minWidth) / 2;
		var y1 = dimensionLargerThanMin ? (realHeight - yInit) / 2 + shorterDimensionOffset / 2 : (realHeight - minHeight) / 2;

		var x2 = dimensionLargerThanMin ? (xInit + x1) - shorterDimensionOffset : x1 + minWidth;
		var y2 = dimensionLargerThanMin ? (yInit + y1) - shorterDimensionOffset : y1 + minHeight;

		var xOffset = 0;
		var yOffset = 0;

		var imgSelectOptions = {
			handles: true,
			keys: true,
			instance: true,
			persistent: true,
			aspectRatio: xInit + ':' + yInit,
			imageWidth: realWidth,
			imageHeight: realHeight,
			minWidth: minWidth / 2,
			minHeight: minHeight / 2,
			x1: Math.floor(x1) + xOffset,
			y1: Math.floor(y1) + yOffset,
			x2: Math.floor(x2) - xOffset,
			y2: Math.floor(y2) - yOffset
		};

		console.log(imgSelectOptions);

		return imgSelectOptions;
	}

	let cropAndDeleteButton = setInterval(function(){
		const cropButtons = $('.media-frame-toolbar .button.media-button.media-button-insert');
		cropButtons.each(function(){
			if(!$(this).closest('.media-toolbar-primary.search-form').find('.delete-original-crop').length) {
				$(this).before('<button type="button" class="button media-button button-primary button-large media-button-insert delete-original-crop">Crop image and delete original</button>');
			}
		});
	}, 500);

	$(document).on('click', '.delete-original-crop', function(e) {
		e.preventDefault();

		const deleteButton = $(this);
		const frame = wp.media.frames.customBackground;
		const attachment = frame.state().get('selection').first().toJSON();

		// Listen for cropped image
		frame.once('cropped', function(croppedImage) {
			// Do your update and delete here
			updateUploadDisplay($('.select-popup-button.upload'), croppedImage.id);

			data = {
				action: 'sc_field_editor_delete_original_after_cropping',
				attachment_id: attachment.id
			};

			$.post('/wp-admin/admin-ajax.php', data, function(response) {
				console.log(response);
				frame.close();
			});
		});

		// Simulate click on "Crop Image" button
		deleteButton.closest('.media-frame-toolbar').find('.button.media-button-insert:not(.delete-original-crop)').trigger('click');
	});
});